import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes";
import { formatMoneda, validaMonto } from "../../../util/varios";
import axios from "axios";
import { Dimmer } from "../../spinner";
//UI
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
import { Radio, Input } from "../../../ui/inputs/Input";
export const ModalConfiguracionLicores = (props) => {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const radioAnual = useRef();
  const radioTrimestral = useRef();
  const radioMensual = useRef();
  const [bloquear, setDesbloquear] = useState(true);
  const [bloquear2, setDesbloquear2] = useState(true);
  const [values, setValues] = useState({
    periodopag: 0,
    periododeclaracio: 0,
    factorcalcul: 0,
    valorporcentua: 0,
    tipointere: 0,
    porcentajeintere: 0,
    porcentajerecarg: 0,
    mesesdecladef: 0,
    ptoimpr: 0,
    diavendeud: 0,
    factormult: 0,
    valormult: 0,
    diavendeudare: 0,
    declaracionwe: 0,
    notifrit: 0,
    diavendeuda1: 0,
    diavendeuda2: 0,
    mesdesdequincen: 0,
    porcenimpuest: 0,
  });
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [records] = useState([]);
  const txtInteresMora = useRef();
  const txtRecargoMora = useRef();

  const onChangeChecked = (e) => {
    if (e.target.name === "periodopag") {
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
    }
    if (e.target.name === "factorcalcul") {
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
    } else if (e.target.name === "tipointere") {
      if (e.target.value === "1") {
        setDesbloquear2(false);
      } else {
        txtInteresMora.current.value = "0,00";
        setDesbloquear2(true);
      }
    } else if (e.target.name === "declaracionwe") {
      console.log(e.target.value === "true" ? true : false);
      setValues({
        ...values,
        [e.target.name]: e.target.value === "true" ? true : false,
      });
    }
  };

  const actualizarConfig = () => {
    let endpoint = `${op.conexion}/api/comun/actualizarmodulo`;
    let body;
    setActivate(true);
    body = {
      tipoconf: 7,
      periodo: parseInt(values.periodopag),
      factor: parseInt(values.factorcalcul),
      valor: null,
      decla: null,
      tipint: parseInt(values.tipointere),
      porint: txtInteresMora.current.value.replace(",", "."),
      porrec: txtRecargoMora.current.value.replace(",", "."),
      meses: null,
      diaven: null,
      diavenreg: null,
      pto: null,
      factor1: null,
      valormul: null,
      declaweb: values.declaracionwe,
      diavenqui1: null,
      diavenqui2: null,
      cmbMes: null,
      descu: records,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setTitulo("Notificacion");
          setMsg("Configuración Actualizada.");
          setMostrar(true);
          seleccionnarModulo();
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };
  const salir = () => {
    props.setShow(false);
    props.setTabla(0);
  };
  const desbloquear = () => {
    setDesbloquear(false);
  };
  const handleCloseMensa = () => {
    setMostrar(false);
    props.setShow(false);
  };
  const seleccionnarModulo = () => {
    let nomtab = "configlicores";
    let endpoint =
      op.conexion + `/api/comun/seleccionarmodulo?&nomtab=${nomtab}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setValues(response.data);
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const handleInputMonto = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  useEffect(() => {
    seleccionnarModulo();
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">Configuración de Rentas Licores</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap" onClick={desbloquear}>
        <div className="col-6 m-0 p-0">
          <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
            <legend className="float-none w-auto m-0">
              Periódo de Pagos
            </legend>
            <div className="col-auto m-0 p-0">
              <Radio label = 'Anual'
                ref={radioAnual}
                defaultChecked={values.periodopag === 1 ? true : false}
                value={1}
                onChange={onChangeChecked}
                name="periodopag"
                id="periodopagos1"
              />
            </div>
            <div className="col-auto m-0 p-0">
              <Radio label = 'Trimestral'
                ref={radioTrimestral}
                defaultChecked={values.periodopag === 2 ? true : false}
                value={2}
                onChange={onChangeChecked}
                name="periodopag"
                id="periodopagos2"
              />
            </div>
            <div className="col-auto m-0 p-0">
              <Radio label = 'Mensual'
                ref={radioMensual}
                defaultChecked={values.periodopag === 3 ? true : false}
                value={3}
                onChange={onChangeChecked}
                name="periodopag"
                id="periodopagos3"
              />
            </div>
          </fieldset>
        </div>
        <div className="col-6 m-0 p-0 pl-2">
          <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
            <legend className="float-none w-auto m-0">
              Intereses de Mora
            </legend>
            <div className="col-auto m-0 p-0">
              <Radio label = 'Fijo'
                name="tipointere"
                value={1}
                defaultChecked={
                  values.tipointere === 1 ? true : false
                }
                id="tipointere1"
                onChange={onChangeChecked}
              />
            </div>
            <div className="col-auto m-0 p-0">
              <Input
                disabled={bloquear2}
                defaultValue={formatMoneda(
                  values.porcentajeintere
                    .toString()
                    .replace(",", "")
                    .replace(".", ","),
                  ",",
                  ".",
                  2
                )}
                onKeyUp={handleInputMonto}
                ref={txtInteresMora}
              />
            </div>
            <div className="col-auto m-0 p-0">
              <Radio label = 'Según Tasa'
                name="tipointere"
                value={2}
                defaultChecked={
                  values.tipointere === 2 ? true : false
                }
                id="tipointere2"
                onChange={onChangeChecked}
              />
            </div>
          </fieldset>
        </div>
        <fieldset className="col-12 m-0 mb-2 p-2 border-azul rounded d-flex gap-2">
          <legend className="float-none w-auto m-0">
            Fáctor para el Calculo
          </legend>
          <div className="col-auto m-0 p-0">
            <Radio label = 'Bolivares (Bs.)'
              name="factorcalcul"
              value={1}
              defaultChecked={values.factorcalcul === 1 ? true : false}
              id="factorcalcul1"
              onChange={onChangeChecked}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio label = 'Unidades Tributarias (U.T.)'
              name="factorcalcul"
              value={2}
              defaultChecked={values.factorcalcul === 2 ? true : false}
              id="factorcalcul2"
              onChange={onChangeChecked}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio label = 'Petros'
              name="factorcalcul"
              value={3}
              defaultChecked={values.factorcalcul === 3 ? true : false}
              id="factorcalcul3"
              onChange={onChangeChecked}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio label = 'Sueldo Minimo'
              name="factorcalcul"
              value={4}
              defaultChecked={values.factorcalcul === 4 ? true : false}
              id="factorcalcul4"
              onChange={onChangeChecked}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio label = 'UCAMP' 
              name="factorcalcul"
              value={5}
              defaultChecked={values.factorcalcul === 5 ? true : false}
              id="factorcalcul5"
              onChange={onChangeChecked}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio label = 'Otros.'
              name="factorcalcul"
              value={6}
              defaultChecked={values.factorcalcul === 6 ? true : false}
              id="factorcalcul6"
              onChange={onChangeChecked}
            />
          </div>
        </fieldset>
        <div className="col-12 m-0 p-0 d-flex gap-2">
          <span className="fw-bold m-0 p-0">
            Declaración En Linea (Internet):
          </span>
          <div className="col-auto m-0 p-0">
            <Radio label = 'Si'
              name="declaracionwe"
              value="true"
              defaultChecked={
                values.declaracionwe === true ? true : false
              }
              id="declaracionwe1"
              onChange={onChangeChecked}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio label = 'No'
              name="declaracionwe"
              value="false"
              defaultChecked={
                values.declaracionwe === false ? true : false
              }
              id="declaracionwe2"
              onChange={onChangeChecked}
            />
          </div>
          <div className="col-4 m-0 p-0">
            <Input label = 'Recargos por Mora'
              inputClassName = 'text-end'
              defaultValue={formatMoneda(
                values.porcentajerecarg
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              )}
              onKeyUp={handleInputMonto}
              ref={txtRecargoMora}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton disabled={bloquear} onClick={actualizarConfig}>
          Aceptar
        </SuccessButton>
        <DangerButton onClick={salir}>Salir</DangerButton>
      </Modal.Footer>
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />
      <Dimmer active={activate}></Dimmer>
    </Modal>
  );
};
